<template>
  <div class="page-table">
    <BasicTable
      :columns="columns"
      :data="data"
      stripe
      border
      v-bind="tableProps"
    />
    <div class="table-page">
      <el-pagination
        ref="pageRef"
        :page-size="page.pageSize"
        :current-page="page.current"
        :total="page.total"
        :background="true"
        layout="total,sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import BasicTable from "./basicTable.vue";

export default defineComponent({
  props: {
    columns: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    page: {
      type: Object,
      default: () => {
        return {
          current: 1,
          pageSize: 10,
          total: 0,
        };
      },
    },
  },
  setup(props, context) {
    const tableProps = computed(() => {
      const tableAttrs = {};
      const eventKeys = ["onCurrentChange", "onSizeChange", "onSortChange"];
      Object.keys(context.attrs).forEach((key) => {
        if (!eventKeys.includes(key)) {
          tableAttrs[key] = context.attrs[key];
        }
      });
      return tableAttrs;
    });

    // events
    const handleSizeChange = (val) => {
      context.emit("size-change", val);
    };
    const handleCurrentChange = (val) => {
      context.emit("current-change", val);
    };

    return {
      tableProps,
      handleSizeChange,
      handleCurrentChange,
    };
  },
  components: { BasicTable },
});
</script>

<style lang="scss" scoped>
.page-table {
  .table-page {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}
</style>
